var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftTurquoise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_Arrow_Right_4",
    "data-name": "Icon - Arrow Right 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13.741,
    viewBox: "0 0 14 13.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_-_Arrow_Right_4-2",
    "data-name": "Icon - Arrow Right 4",
    d: "M7.7,2.092q1.563,2.542,3.2,5.029c-1.056,1.6-2.355,3.014-3.463,4.574-1.053,1.485,1.4,2.895,2.435,1.423,1.288-1.818,2.835-3.435,3.957-5.368A1.53,1.53,0,0,0,13.5,5.942Q11.773,3.334,10.138.668A1.316,1.316,0,0,0,8.989,0,1.393,1.393,0,0,0,7.7,2.092Zm-7.183,0q1.565,2.542,3.2,5.029C2.664,8.712,1.364,10.13.258,11.692c-1.053,1.485,1.4,2.89,2.435,1.428C3.98,11.3,5.526,9.685,6.65,7.753a1.53,1.53,0,0,0-.332-1.809Q4.592,3.337,2.955.669A1.314,1.314,0,0,0,1.807,0,1.392,1.392,0,0,0,.52,2.089Z",
    transform: "translate(14 13.741) rotate(180)",
    fill: "#0baaa1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftTurquoise);
export default __webpack_public_path__ + "static/media/arrow_left_turquoise.1661f2272f2a8f88f6b640827abd94ce.svg";
export { ForwardRef as ReactComponent };